<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="600">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">
                    <v-card flat>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-row no-gutters >

                                    <v-col cols="12" sm="12" md="3">
                                        <label class="f-label">{{ $t(fieldname) }}</label>
                                    </v-col>
                                    
                                    <v-col cols="12" sm="12" md="9">
                                        <v-textarea
                                            v-model="comment"
                                            rows="3"
                                            no-resize
                                            hide-details
                                            outlined
                                            dense
                                        >
                                        </v-textarea>
                                    </v-col>

                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                        color="cyan" 
                        text
                        depressed 
                        @click="ok" 
                    >
                        {{$t("Отклонить")}}
                    </v-btn>

                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отмена")}}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "InputBoxDlg",
    props:
    {
        value:
        {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },
        }
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule' }),
        ...mapGetters('global/dialogs/input_box', { visible: 'isVisible', title: 'getTitle', fieldname: 'getFieldname' }),
        comment: {
            get: function() {
                return this.$store.getters['global/dialogs/input_box/getComment'];
            },
            set: function(v) {
                this.$store.commit('global/dialogs/input_box/SET_COMMENT', v); 
            }
        },
    },
    methods: {
        ...mapActions('global/dialogs/input_box', ['ok', 'cancel'])
    }
}
</script>